export const environment = {
  production: false,
  type: 'dev',
  region: 'nam',
  config: {
    ECL_PLATFORM_URL: 'https://ecl-platform.maersk-digital.dev',
    TRACKING_SERVICE_URL: 'https://mectracking-configuration.centralus.dev.maersk.io',
    RUM_API_KEY: '',
    RUM_APP_NAME: 'MecTrackingUI-Dev',
  },
};
